import {Injectable} from '@angular/core';
import {AbstractModelService} from '../model/abstract-model.service';
import {ApiClientService} from '../api-client/api-client.service';
import {Lead} from '../../models/lead';
import {AuthService} from '../auth/auth.service';
import {Observable} from 'rxjs';
import {ApiResponse} from '../../api/api-response';

@Injectable({
  providedIn: 'root'
})
export class LeadService extends AbstractModelService<Lead> {

  constructor(apiClient: ApiClientService, private authService: AuthService) {
    super(apiClient, '/lead', Lead);
  }

  getDownloadUrl(parameters: any = {}): string {
    parameters['token'] = this.authService.getBearer();

    return this.apiClient.getUrl(this.routePath + '/download', parameters);
  }

  getHtmlStatusIcon(lead: Lead): string {
    if (lead.sourceTypology === 'p0') {
      return '📝';
    }

    if (lead.succeeded) {
      return '✅';
    }

    if (lead.reactivated) {
      return '🔁';
    }

    if (lead.alreadyRegistered) {
      return '❌';
    }

    return '⚠️';
  }

  getHtmlStatus(lead: Lead): string {
    if (lead.sourceTypology === 'p0') {
      return 'Pre-registration';
    }

    if (lead.succeeded) {
      return 'OK';
    }

    if (lead.reactivated) {
      return 'Reactivated';
    }

    if (lead.alreadyRegistered) {
      return 'Already Registered';
    }

    return 'Error';
  }

  leadUpPreping(email: string): Observable<any> {
    return new Observable<any>((subscriber) => {
      this.apiClient.get(this.routePath + '/leadup-preping', {
        email: email,
      }).subscribe({
        next: (response: ApiResponse) => {
          subscriber.next(response.getData()['preping']);
          subscriber.complete();
        },
        error: (error) => {
          subscriber.error(error);
          subscriber.complete();
        }
      });
    });
  }

  productPreping(email: string, lang: string, product: string): Observable<any> {
    return new Observable<any>((subscriber) => {
      this.apiClient.post(this.routePath + '/product-preping', {}, {
        email: email,
        lang: lang,
        product: product
      }).subscribe({
        next: (response: ApiResponse) => {
          subscriber.next(response.getData());
          subscriber.complete();
        },
        error: (error) => {
          subscriber.error(error);
          subscriber.complete();
        }
      });
    });
  }
}
